import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHead } from "./Section";
import { FAQS } from "./homeData";

export const Faq = ({ items = FAQS, num = "07", title = "Straight answers." }) => (
  <section id="faq" className="scroll-mt-16 bg-[#F8FAFC] home-grid-light py-24 lg:py-32" data-testid="home-faq">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1fr_1.4fr] gap-12">
      <SectionHead num={num} eyebrow="FAQ" title={title} sub="Still not sure? Send us a message and we'll walk you through it." />
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="rounded-2xl bg-white border border-slate-200 px-6 sm:px-8" data-testid="home-faq-list">
          {items.map((f, i) => (
            <AccordionItem key={f.q} value={`q${i}`} className="border-slate-200 last:border-0">
              <AccordionTrigger data-testid={`home-faq-q-${i}`} className="font-display text-left text-base sm:text-lg font-bold hover:no-underline hover:text-[#EA580C] py-6">{f.q}</AccordionTrigger>
              <AccordionContent className="text-slate-600 text-sm sm:text-base leading-relaxed pb-6" data-testid={`home-faq-a-${i}`}>{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
